import React from 'react'
import { getLeagueBadgeInfo } from '../utils/leagueBadge'

interface LeagueBadgeProps {
  league: string | null | undefined
  className?: string
  /** Pixel size for image badges; emoji uses font-size roughly matching this. */
  size?: number
}

const LeagueBadge: React.FC<LeagueBadgeProps> = ({ league, className = '', size = 48 }) => {
  const badge = getLeagueBadgeInfo(league)
  if (!badge) {
    return (
      <span className={className} style={{ fontSize: size * 0.85 }} aria-hidden>
        ⚽
      </span>
    )
  }

  if (badge.kind === 'image' && badge.imageSrc) {
    return (
      <img
        src={badge.imageSrc}
        alt={badge.label}
        title={badge.label}
        className={`inline-block object-contain ${className}`}
        style={{ width: size, height: size }}
      />
    )
  }

  return (
    <span
      className={`inline-block leading-none ${className}`}
      style={{ fontSize: size * 0.85 }}
      title={badge.label}
      role="img"
      aria-label={badge.label}
    >
      {badge.emoji}
    </span>
  )
}

export default LeagueBadge
